import React from 'react';
import { CHAIN_KEYS } from '../chains/interfaces';

const SolanaLogo = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="solana-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#14F195" />
        <stop offset="100%" stopColor="#9945FF" />
      </linearGradient>
    </defs>
    <rect x="3" y="3" width="26" height="26" rx="13" fill="#121212" />
    <path d="M9 10h14l-2 3H7z" fill="url(#solana-grad)" />
    <path d="M11 14h14l-2 3H9z" fill="url(#solana-grad)" />
    <path d="M9 18h14l-2 3H7z" fill="url(#solana-grad)" />
  </svg>
);

const EthereumLogo = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 256 417" xmlns="http://www.w3.org/2000/svg">
    <path fill="#8c8c8c" d="M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z" />
    <path fill="#f2f2f2" d="M127.962 0L0 212.32l127.962 75.639V154.158z" />
    <path fill="#8c8c8c" d="M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z" />
    <path fill="#f2f2f2" d="M127.962 416.905v-104.72L0 236.585z" />
    <path fill="#5f5f5f" d="M127.962 287.995l127.962-75.637-127.962-58.162z" />
    <path fill="#c9c9c9" d="M0 212.32l127.962 75.675v-133.837z" />
  </svg>
);

const BscLogo = ({ size }) => (
  <img
    src="/chains/bsc-logo.jpg"
    alt=""
    width={size}
    height={size}
    style={{ display: 'block', borderRadius: '50%' }}
  />
);

const AdiLogo = ({ size }) => (
  <img
    src="/chains/adi-symbol.jpg"
    alt=""
    width={Math.round(size * 0.9)}
    height={size}
    style={{ display: 'block', borderRadius: '50%' }}
  />
);

export const ChainIcon = ({ chainKey, size = 16 }) => {
  let logo = null;
  let variant = 'circle';

  if (chainKey === CHAIN_KEYS.BSC) {
    logo = <BscLogo size={size} />;
    variant = 'plain';
  } else if (chainKey === CHAIN_KEYS.ADI) {
    logo = <AdiLogo size={Math.round(size * 1.35)} />;
    variant = 'adi';
  } else if (chainKey === CHAIN_KEYS.SOLANA) {
    logo = <SolanaLogo size={Math.round(size * 1.55)} />;
    variant = 'solana';
  } else if (chainKey === CHAIN_KEYS.ETHEREUM) {
    logo = <EthereumLogo size={size} />;
  }

  if (!logo) return null;

  return (
    <span
      className={`chain-icon-bubble chain-icon-bubble--${variant}`}
      style={{ '--chain-icon-size': `${size}px` }}
      aria-hidden="true"
    >
      {logo}
    </span>
  );
};
